import "react-toastify/dist/ReactToastify.css";
import "./ModernApp.css";
import "./styles/responsive.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useEffect, useState } from "react";
import apiRoutes from "./constants/apiRoutes";
import Dashboard from "./pages/Dashboard";
import Information from "./pages/Information";
import ContactDetails from "./pages/ContactDetails";
import Create from "./pages/Create";
import Setting from "./pages/Setting";
import Splash from "./pages/Splash";
import ModernScanCard from "./pages/ModernScanCard";
import { ThemeContextProvider } from './contexts/ThemeContext';
import ProtectedRoute from "./components/ProtectedRoute";
import PWAInstallPrompt from "./components/PWAInstallPrompt";

function App() {
  const [isLoggedin, setIsLoggedin] = useState(false);

  const checkUserLoggedInOrNot = () => {
    const userInfo = localStorage.getItem("idToken");
    if (userInfo) {
      setIsLoggedin(true);
    }
  };

  useEffect(() => {
    checkUserLoggedInOrNot();
  }, []);

  return (
    <ThemeContextProvider>
      <GoogleOAuthProvider clientId="168552994191-i89aku25bkv9vg655rp4ebq820p6uvs3.apps.googleusercontent.com">
        <Router>
          <Routes>
            <Route path="/" element={!isLoggedin ? <Splash /> : <Dashboard />} />
            <Route path={apiRoutes.SPLASH} element={<Splash />} />
            
            {/* Protected Routes */}
            <Route 
              path={apiRoutes.DASHBOARD} 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path={apiRoutes.INFO} 
              element={
                <ProtectedRoute>
                  <Information />
                </ProtectedRoute>
              } 
            />
            <Route
              path={apiRoutes.CONTACT_DETAILS}
              element={
                <ProtectedRoute>
                  <ContactDetails />
                </ProtectedRoute>
              }
            />
            <Route 
              path={apiRoutes.CREATE} 
              element={
                <ProtectedRoute>
                  <Create />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/settings" 
              element={
                <ProtectedRoute>
                  <Setting />
                </ProtectedRoute>
              } 
            />
            <Route 
              path={apiRoutes.SCAN} 
              element={
                <ProtectedRoute>
                  <ModernScanCard />
                </ProtectedRoute>
              } 
            />

            {/* Fallback route */}
            <Route path="*" element={<div>Page Not Found</div>} />
          </Routes>
          
          {/* PWA Install Prompt */}
          <PWAInstallPrompt />
        </Router>
      </GoogleOAuthProvider>
    </ThemeContextProvider>
  );
}

export default App;
